import React, { useEffect, useMemo, useState } from "react";
// import "../CommonStyle.css";
import MDPersonalInfo from "./MDPersonalInfo";
import MDPrimaryAddress from "./MDPrimaryAddress";
import MemberServices from "../../services/MemberServices";
import MDPublishedAddress from "./MDPublishedAddress";
import MDFirmDetail from "./MDFirmDetail";
// import MDOtherStateBar from "./MDOtherStateBar";
import MDMemberTags from "./MDMemberTags";
import MDSections from "./MDSections";
import MDComments from "./MDComments";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { currentMemberSlice } from "../../store/currentMemberSlice";
import IMember from "../../store/memberInterfaceStruct";
import MDOtherStateBar from "./MDOtherStateBar";
import { screenConfig } from "../../config/screenConfig";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import "../../Styles/TableStyles.scss";
import "../../Styles/memberModal.css";
import "../../Styles/CommonStyles.scss";
import {
  Button,
  Label,
  PageLink,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import ButtonWithIcon from "../StyledComp/ButtonWithIcon";
import OrderIcon from "../../Images/MemberIconComp/OrderIcon";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {
  IOrder,
  resetOrderParameters,
  storeResetOrder,
  storeUpdateOrder,
} from "../../store/orderApiSlice";
import { IoListCircle } from "react-icons/io5";
import * as routeConfig from "../../config/routes";

import ReactModal from "react-modal";

import MDEventDetails from "./MDEventDetails";
import HistoryIcon from "@mui/icons-material/History";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import TextField from "@mui/material/TextField";
import { IPaymentInfo } from "../../store/memberInterfaceStruct";
import { Controller, useForm } from "react-hook-form";
import OrderServices from "../../services/OrderServices";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface IConfiguration {
  [key: string]: any;
}

interface IMemberData {
  [key: string]: any;
}

const MemberDetail: React.FC = () => {
  const currentMember = useAppSelector((state) => state.currentMember);
  // console.log("currentMember:", currentMember);
  const memberList = useAppSelector((state) => state.findMemberList);
  const orderInfo = useAppSelector((store) => store.orderapislice);
  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );
  const [orderList, setOrderList] = useState<IOrder[]>([]);

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [isCreateOrderButtonClicked, setIsCreateOrderButtonClicked] =
    React.useState(false);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const formPaymentInfo = useForm<IPaymentInfo>();
  const {
    register: registerPI,
    control: controlPI,
    handleSubmit: handleSubmitPI,
    formState: formStatePI,
    setValue: setValuePI,
    clearErrors: clearErrorsPI,
  } = formPaymentInfo;

  const {
    errors: errorsPI,
    touchedFields: touchedFieldsPI,
    dirtyFields: dirtyFieldsPI,
  } = formStatePI;

  const [PIModalOpen, setPIModalOpen] = useState(false);

  const [memberData, setMemberData] = useState<any>({});
  const [addressData, setAddressData] = useState<any>({});
  const [primaryAddressData, setPrimaryAddressData] = useState<any>({});
  const [publishedAddressData, setPublishedAddressData] = useState<any>({});
  const [sections, setSections] = useState<any>([]);
  const [tags, setMemberTags] = useState<any>([]);
  const [MemberId, setMemberId] = useState("");
  const [editHistory, setEditHistory] = useState<any>([]);
  const currentMemberId = useSelector(
    (state: RootState) => state.memberApiSlice.FindMemberData.MemberId
  );
  // const encodedId = window.btoa(currentMemberId);
  const data = useMemo(() => memberData, [memberData]);
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    if (currentMember.MemberCodeId === null) {
      navigate("/member", { replace: false });
    }
    dispatch(storeResetOrder());

    const openPIModal = async () => {
      // get open orders to make payment

      let orderListAPIParams = {
        MemberId: currentMember.Id,
        OrderType: "Membership",
        OrderStatus: 1,
      };

      const response = await OrderServices.getOrderList(orderListAPIParams);
      if (response.data.data.Orders[0] != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("response1...", response.data.data);
        setOrderList(response.data.data.Orders);

        dispatch(
          storeUpdateOrder({
            key: "MemberId",
            value: response.data.data.Orders[0].MemberId,
          })
        );
        dispatch(
          storeUpdateOrder({
            key: "OrderId",
            value: response.data.data.Orders[0].Id,
          })
        );
      } else {
        console.log("error");
      }
    };

    openPIModal();
  }, []);

  useEffect(() => {
    console.log(
      "in MD-isCreateOrderButtonClicked:",
      isCreateOrderButtonClicked
    );
  }, [isCreateOrderButtonClicked]);
  // const updatePaymentInfo = (e: any, date?: Date | null) => {
  //   switch (e.target.name) {
  //     case "PaymentMethod":
  //       // setPaymentInfo((prevValues) => ({
  //       //   ...prevValues,
  //       //   PaymentMethod: e.target.value,
  //       // }));
  //       dispatch(
  //         storeUpdateOrder({
  //           key: "PaymentMethod",
  //           value: e.target.value,
  //         })
  //       );
  //       break;

  //     case "DatePaid":
  //       // const formattedDate = date ? dayjs(date) : null;
  //       // setPaymentInfo((prevValues) => ({
  //       //   ...prevValues,
  //       //   DatePaid: formattedDate,
  //       // }));
  //       dispatch(
  //         storeUpdateOrder({
  //           key: "DatePaid",
  //           value: e.target.value,
  //         })
  //       );

  //       break;

  //     case "CheckNumber":
  //       // setPaymentInfo((prevValues) => ({
  //       //   ...prevValues,
  //       //   CheckNo: e.target.value,
  //       // }));
  //       dispatch(
  //         storeUpdateOrder({
  //           key: "CheckNumber",
  //           value: e.target.value,
  //         })
  //       );
  //       break;

  //     case "TransactionAmount":
  //       // setPaymentInfo((prevValues) => ({
  //       //   ...prevValues,
  //       //   AmountPaid: e.target.value,
  //       // }));
  //       dispatch(
  //         storeUpdateOrder({
  //           key: "TransactionAmount",
  //           value: e.target.value,
  //         })
  //       );
  //       break;

  //     case "LateFee":
  //       // setPaymentInfo((prevValues) => ({
  //       //   ...prevValues,
  //       //   LateFee: e.target.value,
  //       // }));
  //       dispatch(
  //         storeUpdateOrder({
  //           key: "LateFee",
  //           value: e.target.value,
  //         })
  //       );
  //       break;

  //     case "AuthCode":
  //       // setPaymentInfo((prevValues) => ({
  //       //   ...prevValues,
  //       //   AuthCode: e.target.value,
  //       // }));
  //       dispatch(
  //         storeUpdateOrder({
  //           key: "AuthCode",
  //           value: e.target.value,
  //         })
  //       );
  //       break;

  //     case "PIcomments":
  //       // setPaymentInfo((prevValues) => ({
  //       //   ...prevValues,
  //       //   PIComments: e.target.value,
  //       // }));
  //       dispatch(
  //         storeUpdateOrder({
  //           key: "Comments",
  //           value: e.target.value,
  //         })
  //       );
  //       break;

  //     case "NoInvoiceFlag":
  //       // setPaymentInfo((prevValues) => ({
  //       //   ...prevValues,
  //       //   NoInvoiceFlag: false,
  //       // }));
  //       dispatch(
  //         storeUpdateOrder({
  //           key: "NoInvoice",
  //           value: e.target.checked,
  //         })
  //       );
  //       break;

  //     default:
  //       console.log("default");
  //       break;
  //   }
  // };

  // const onSubmitPaymentInfo = async (e: any) => {
  //   // e.preventDefault();
  //   console.log("onSUBMIT:", orderInfo);

  //   const apiBody: any = orderInfo;
  //   const response = await OrderServices.createPayment(apiBody);

  //   if (response.data.data != null) {
  //     alert("Payment Posted successfully");
  //     console.log("Payment response:", response);
  //     setPIModalOpen(false);
  //     dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  //     navigate("/member/findmember", { replace: true });
  //     //   // dispatch(resetOrderParameters());  I am doing this in useEffect
  //     //   // navigate("/order", { replace: true });
  //     //   // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
  //     //   // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

  //     //   dispatch(
  //     //     storeUpdateOrder({
  //     //       key: "TransactionAmount",
  //     //       value: 0,
  //     //     })
  //     //   );

  //     //   // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  //     //   navigate("/member/findmember", { replace: false });
  //     //   // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
  //     //   //  dispatch(screenChange("Events"));
  //   } else {
  //     alert(response.data.errors);
  //     console.log("error");
  //   }
  // };

  const handleCancel = () => {
    setPIModalOpen(false);
  };

  const closeMemberDetail = () => {
    navigate("/member", { replace: false });
    // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  };

  // const createOrder = () => {
  //   // dispatch(resetOrderParameters());
  //   dispatch(changeCurrentMemberMenu(screenConfig.createOrder));
  // };

  const updatePayment = () => {
    // dispatch(changeCurrentMemberMenu(screenConfig.updatePayment));
  };

  const ViewOrder = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("orders.view")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log(currentMemberId, "***************");
    setMemberId(currentMemberId);
    // navigate("/order?MemberId=" + encodedId, { replace: true });
    navigate("/order?MemberId=" + window.btoa(currentMemberId), {
      replace: true,
    });

    console.log(currentMemberId);
  };

  const ViewInvoice = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("invoice.view")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log(currentMemberId, "***************");
    // navigate("/invoice?MemberId=" + encodedId, { replace: true });
    navigate("/invoice?MemberId=" + window.btoa(currentMemberId), {
      replace: true,
    });
  };

  const compareObjects = (
    previous: any,
    changed: any,
    changeType: any
  ): { [key: string]: { previous: any; changed: any } } => {
    console.log(
      previous,
      changed,
      changeType,
      "&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&"
    );
    if (changeType == "Member-Other-Bar") {
      const differences = {
        OtherStateBarName: {
          previous: JSON.stringify(previous),
          changed: JSON.stringify(changed),
        },
      };
      console.log(differences);
      return differences;
    } else {
      const differences: { [key: string]: { previous: any; changed: any } } =
        {};
      for (let key in previous) {
        if (previous.hasOwnProperty(key) && changed.hasOwnProperty(key)) {
          if (previous[key] !== changed[key]) {
            differences[key] = {
              previous: previous[key],
              changed: changed[key],
            };
          }
        }
      }
      console.log("Differences:", differences);
      return differences;
    }
  };

  const color1 = "#2d6289";
  const color2 = "#008800";
  const colorError = "#FF0000";
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });
  //   const compareObjects = (previous: any, changed: any, changeType: any): { [key: string]: { previous: any, changed: any } } => {
  //     const differences: { [key: string]: { previous: any, changed: any } } = {};

  //     if (Array.isArray(previous) && Array.isArray(changed)) {
  //         for (let i = 0; i < previous.length; i++) {
  //             const prevObj = previous[i];
  //             const changedObj = changed[i];
  //             const objDifferences = compareObjects(prevObj, changedObj, changeType);
  //             Object.assign(differences, objDifferences);
  //         }

  //         if (changed.length > previous.length) {
  //             for (let i = previous.length; i < changed.length; i++) {
  //                 for (let key in changed[i]) {
  //                     if (changed[i].hasOwnProperty(key)) {
  //                         differences[key] = {
  //                             previous: '-',
  //                             changed: changed[i][key]
  //                         };
  //                     }
  //                 }
  //             }
  //         }
  //     } else if (typeof previous === 'object' && typeof changed === 'object') {
  //         for (let key in previous) {
  //             if (previous.hasOwnProperty(key) && changed.hasOwnProperty(key)) {
  //                 if (previous[key] !== changed[key]) {
  //                     differences[key] = {
  //                         previous: previous[key],
  //                         changed: changed[key]
  //                     };
  //                 }
  //             }
  //         }
  //     }
  //     console.log('Differences:', differences);

  //     return differences;
  // };

  // const getEditHistory = async () => {
  //   console.log("getEditHistory");
  //   const response = await MemberServices.getMemberEditHistory({
  //     MemberId: currentMemberId,
  //   });
  //   console.log("response", response.data);
  //   if (response.data.data != null) {
  //     // alert("no error");
  //     console.log(response.data);
  //     let changeHistory = response.data.data;
  //     changeHistory.map((entity: any) => {
  //       entity.ChangedValue = JSON.parse(entity.ChangedValue);
  //       entity.PreviousValue = JSON.parse(entity.PreviousValue);
  //     });
  //     changeHistory.forEach((element:any) => {
  //      console.log(element);
  //     });
  //     console.log("after");
  //     console.log(changeHistory);
  //     setEditHistory(changeHistory);

  //   } else {
  //     alert(response.data.errors);
  //     console.log("error");
  //   }
  // };
  const getEditHistory = async () => {
    console.log("getEditHistory");
    const response = await MemberServices.getMemberEditHistory({
      MemberId: currentMemberId,
    });
    console.log("response", response.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      // alert("no error");
      console.log(response.data);
      let changeHistory = response.data.data;
      changeHistory.map((entity: any) => {
        console.log(entity);
        entity.ChangedValue = JSON.parse(entity.ChangedValue);
        entity.PreviousValue = JSON.parse(entity.PreviousValue);
        console.log(entity.PreviousValue);
        if (Array.isArray(entity.PreviousValue)) {
          entity.PreviousValue.forEach((item: any) => {
            item.AdmitDate = dayjs(item.AdmitDate).format("YYYY-MM-DD");
          });
        }
      });
      console.log("after");
      console.log(changeHistory);
      // changeHistory = changeHistory.filter((item:any) => {
      //   if (item.ChangeType != 'Member-Other-Bar') {
      //     return item;
      //   }
      // })
      console.log(changeHistory);

      changeHistory.map((item: any) => {
        if (item.ChangeType != "Member-Other-Bar") {
          console.log(
            item,
            "*********************************************************************************"
          );
          const previousValue = item.PreviousValue;
          const changedValue = item.ChangedValue;
          if (previousValue.AdmitDate) {
            previousValue.AdmitDate = dayjs(previousValue.AdmitDate).format(
              "YYYY-MM-DD"
            );
          }
          if (previousValue.DateOfBirth) {
            previousValue.DateOfBirth = dayjs(previousValue.DateOfBirth).format(
              "YYYY-MM-DD"
            );
          }
          console.log(previousValue, changedValue);
          const differences = compareObjects(
            previousValue,
            changedValue,
            item.ChangeType
          );
          console.log(`Differences for item with Id ${item.Id}:`);
          console.log(differences);
        } else {
          console.log(
            item,
            "%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%"
          );
        }
      });
      console.log(changeHistory);
      setEditHistory(changeHistory);
    } else {
      alert(response.data.errors);
      console.log("error");
    }
  };
  // useEffect(() => {
  //   getEditHistory();
  // }, []);
  // const handleMemberId = (data:any) => {
  //   setMemberId(data);
  // };
  const printMember = () => {
    console.log("printMember " + currentMember);
    navigate("/member/member-detail/print", { state: { member: currentMember } });
  };
  const editHistroy = () => {
    setModalIsOpen(true);
    getEditHistory();
  };
  return (
    <div
      className="dashboard-content-wrapper"
      // style={{ marginBottom: "100px" }}
    >
      <div
        className="horizontal-wrapper-spacebetween"
        style={{ marginTop: "0.5rem" }}
      >
        <h1 className="page-heading">Members Details</h1>
        {/* for sunder to proceed from here */}
        {/* <Button className="w-4" onClick={getEditHistory}> Edit History</Button> */}

        <div className="d-flex">
        <div className="secondary-button1">
            {/* <Link to={"/order?MemberId=" + encodedId} className="menubar-link"> */}
            <SecondaryWhiteButton
              className="button-wrapper"
              type="submit"
              onClick={printMember}
            >
              {/* <button onClick={editHistroy} className="history-button me-3"> */}
              Print Member
              {/* </button> */}
            </SecondaryWhiteButton>
          </div>
          <div className="secondary-button1">
            {/* <Link to={"/order?MemberId=" + encodedId} className="menubar-link"> */}
            <SecondaryWhiteButton
              className="button-wrapper"
              type="submit"
              onClick={editHistroy}
            >
              {/* <button onClick={editHistroy} className="history-button me-3"> */}
              <HistoryIcon /> Edit History
              {/* </button> */}
            </SecondaryWhiteButton>
          </div>
          {/* <div className="secondary-button1">
            <SecondaryWhiteButton
              className="button-wrapper"
              type="submit"
              onClick={() => {
                setIsCreateOrderButtonClicked(true);
              }}
            >
              <OrderIcon height={23} width={23} /> Create Order
            </SecondaryWhiteButton>
          </div> */}
          <div className="secondary-button1">
            <SecondaryWhiteButton
              className="button-wrapper"
              type="submit"
              onClick={ViewOrder}
            >
              <span style={{ fontWeight: "500" }}> My Orders</span>
            </SecondaryWhiteButton>

            {/* </Link> */}
          </div>

          <div className="secondary-button1">
            {/* <Link to={"/invoice?MemberId=" + encodedId} className="menubar-link"> */}
            <SecondaryWhiteButton
              className="button-wrapper"
              type="submit"
              onClick={ViewInvoice}
            >
              <span style={{ fontWeight: "500" }}> View Invoices</span>
            </SecondaryWhiteButton>

            {/* </Link> */}
          </div>

          {/* <div
            className="secondary-button1"
            style={{ width: "auto", height: "auto" }}
          >
            <SecondaryWhiteButton
              className="button-wrapper"
              type="submit"
              // onClick={openChangeHistory}
            >
              <span style={{ fontWeight: "500" }}> Change History</span>
            </SecondaryWhiteButton>
          </div> */}
          {/* <div className="secondary-button1"> */}
          {/* <Link to="/order/update-payment" className="menubar-link"> */}
          {/* <ButtonWithIcon
              icon={<OrderIcon height={25} width={25} />}
              buttontext="Update Payment"
              isDisabled={orderList.length === 0}
              // onClick={updatePayment}
              onClick={() => setPIModalOpen(true)}
            /> */}
          {/* </Link> */}
          {/* </div> */}
          {/* <div className="secondary-button1">
            <Link to="/order/create-order" className="menubar-link">
              <ButtonWithIcon
                icon={<OrderIcon height={25} width={25} />}
                buttontext="Create Order"
                onClick={createOrder}
                // onClick={() => setPIModalOpen(true)}
              />
            </Link>
          </div> */}
        </div>
      </div>
      <h1 className="page-heading"></h1>

      {currentMember.MemberCodeId && (
        <>
          {/* ReactModal component start */}
          <ReactModal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            overlayClassName="overlay"
          >
            <div className="d-flex justify-content-between">
              <h5 style={{ color: "#2d6289" }}>Edit History</h5>
              <div></div>
              <PageLink onClick={() => setModalIsOpen(false)}>Cancel</PageLink>
            </div>
            {editHistory.length > 0 ? (
              <table className="persionalinformation-table">
                <thead>
                  <tr>
                    <th style={{ borderBottom: "0px" }}></th>
                    <th style={{ borderBottom: "0px" }}></th>
                    <th className="text-center">Changes Done</th>
                  </tr>
                  <tr>
                    <th style={{ borderTop: "0px", width: "8%" }}>
                      Updated by
                    </th>
                    <th style={{ borderTop: "0px", width: "10%" }}>
                      Updated Time
                    </th>
                    <th className="p-0">
                      <div className="d-flex">
                        <span className="table-header-field">Field</span>
                        <span className="table-header">Previous Value</span>
                        <span
                          className="table-header"
                          style={{ borderRight: "0px" }}
                        >
                          Updated Value
                        </span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {editHistory.map((item: any) => (
                    <tr key={item.Id}>
                      {Object.entries<{ previous: string; changed: string }>(
                        compareObjects(
                          item.PreviousValue,
                          item.ChangedValue,
                          item.ChangeType
                        )
                      ).length > 0 ? (
                        <>
                          <td>{item.ChangedByAdmin}</td>
                          <td>
                            {dayjs(item.CreatedAt).format(
                              "YYYY-MM-DD hh:mm:ss A"
                            )}
                          </td>
                          <td className="p-0">
                            {Object.entries<{ previous: any; changed: any }>(
                              compareObjects(
                                item.PreviousValue,
                                item.ChangedValue,
                                item.ChangeType
                              )
                            ).map(([key, value]) => (
                              <div key={key} className="d-flex">
                                <span className="table-header-field">
                                  {key}
                                </span>
                                <span className="table-header">
                                  {value.previous || "-"}
                                </span>
                                <span
                                  className="table-header"
                                  style={{ borderRight: "0px" }}
                                >
                                  {value.changed || "-"}
                                </span>
                              </div>
                            ))}
                          </td>
                        </>
                      ) : (
                        <></>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <h6 className="d-flex justify-content-center">
                No edit history data available.
              </h6>
            )}
          </ReactModal>
          {/* ReactModal component  end */}
          <MDPersonalInfo />
          <MDPrimaryAddress />
          <MDPublishedAddress />
          <MDSections />
          <MDMemberTags />
          <MDOtherStateBar />
          <MDEventDetails
            isCreateOrderButtonClicked={isCreateOrderButtonClicked}
            setIsCreateOrderButtonClicked={setIsCreateOrderButtonClicked}
          />
        </>
      )}
      {/*<MDComments
      // MemberCode={configurationList.MemberCode}
      // MemberType={configurationList.MemberTypes}
      // // Comments={memberData[0].Comments}
      // Comments={"testComments"}
      /> */}
      {/* <div className="submit-floating-button-div">
        <Button
          className="submit-button-div"
          type="button"
          onClick={() => {
            closeMemberDetail();
          }}
        >
          Close
        </Button>
      </div> */}

      <div
        className="button-wrapper"
        style={{ width: "100%", marginTop: "2rem", marginBottom: "100px" }}
      >
        <div className="submit-button-div">
          <Button
            type="button"
            onClick={() => {
              closeMemberDetail();
            }}
          >
            Close
          </Button>
        </div>
      </div>
      {/* <ReactModal
        isOpen={PIModalOpen}
        onRequestClose={() => setPIModalOpen(false)}
        className="editinfo-modal-medium"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Update Pay Information</h1>
          <PageLink onClick={handleCancel}>Cancel</PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmitPI(onSubmitPaymentInfo)}
          noValidate
        >
          <div className="input-field-div-wrapper">
            <select
              className="dropdown-control-large-insidetextfield"
              name="PaymentMethod"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            >
              <option value={""}> Select Payment Type </option>
              <option value="American Express">American Express</option>
              <option value="Authorize.net">Authorize.net</option>
              <option value="Check">Check</option>
              <option value="Discover">Discover</option>
              <option value="MasterCard">MasterCard</option>
              <option value="Visa">Visa</option>
              <option value="Website">Website</option>
            </select>
          </div>

          <div style={{ width: "28%", marginBottom: "1.8rem" }}>
            <Controller
              control={controlPI}
              name="DatePaid"
              // rules={{ required: "* required field" }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Date Paid"
                      value={value ? dayjs(value).toDate() : null}
                      onChange={(date: Date | null) => {
                        const formattedDate = date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : null;
                        const syntheticEvent = {
                          target: {
                            name: "DatePaid",
                            value: date
                              ? dayjs(date).format("YYYY-MM-DD")
                              : null,
                          },
                        };
                        updatePaymentInfo(syntheticEvent, date);
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="CheckNumber"
              name="CheckNumber"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="CheckNumber">
              Check Number
            </label>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="TransactionAmount"
              name="TransactionAmount"
              pattern="[0-9]*"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              value={orderInfo.TotalAmount}
              // disabled={true}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="TransactionAmount">
              Amount Paid
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="LateFee"
              name="LateFee"
              placeholder=""
              pattern="[0-9]*"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="LateFee">
              Late Fee
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="AuthCode"
              name="AuthCode"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="AuthCode">
              Auth Code
            </label>
          </div>

          <div className="textarea-wrapper" style={{ width: "100%" }}>
            <TextField
              className="textarea"
              id="PIcomments"
              name="PIcomments"
              placeholder="Comments"
              multiline
              rows={3}
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            />
          </div>
          <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </ReactModal> */}
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};
export default MemberDetail;
